import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPixels } from './utils/pixels';

const GOOGLE_TAG_ID = process.env.REACT_APP_GOOGLE_TAG_ID?.trim();

if (GOOGLE_TAG_ID) {
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  const googleTagScript = document.createElement('script');
  googleTagScript.async = true;
  googleTagScript.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GOOGLE_TAG_ID)}`;
  document.head.prepend(googleTagScript);

  window.gtag('js', new Date());
  window.gtag('config', GOOGLE_TAG_ID, {
    // Keep one session across the site and Shopify checkout
    linker: { domains: ['themajorities.com', 'c0bqfe-z2.myshopify.com'], decorate_forms: true },
  });
}

initPixels();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
